export const BASE_URL = 'https://unilink.us';
export const BASE_URL_TEST = 'https://unilink-web-dev.azurewebsites.net';
export const avatarEmpty = `${BASE_URL}/content/profile_pic.jpg`;
export const BASE_URL_NEXT = 'unil.ink';
export const BASE_URL_NEXT_LINK = 'https://unil.ink';

export const ROUTES = {
  linkInBio: '/website',
  creatorHub: '/creator-hub',
  studio: '/studio',
  posts: '/posts',
  products: '/products',
  blog: '/blog',
  events: '/products/events',
  appointments: '/products/appointments',
  discounts: '/discounts',
  orders: '/orders',
  payments: '/orders/payments',
  invoices: '/invoices',
  audience: '/audience',
  customers: '/customers',
  subscribers: '/subscribers',
  form: '/embed-forms',
  automations: '/automations',
  email: '/email',
  emails: '/emails',
  scheduler: '/scheduler',
  socialPlanner: '/social-planner',
  adsManager: '/ads-manager',
  aiPosts: '/social-planner/ai-posts',
  aiImages: '/social-planner/ai-images',
  brandProjects: '/social-planner/brand-projects',
  aiVideo: '/social-planner/video-ai',
  socialIntegrations: '/social-planner/integrations',
  integrations: '/integrations',
  pages: '/pages',
  analytics: '/analytics',
  settings: '/settings',
  design: '/design',
  membership: '/membership',
  shortLinks: '/short-links',
  storyWidget: '/story-widget',
  accountSettings: '/account-settings',
  messages: '/messages',
  agents: '/agents',
  standalonePage: '/standalone-page',
  soloApps: '/solo-apps',
  bots: '/bots',
  smartReply: '/smart-reply',
  websiteSettings: '/website/settings',
  articles: '/articles',
  qrCodes: '/qr-codes',
  singlePages: '/single-pages',
  agents: '/agents',
  profileHealth: '/profile-health',
  funnels: '/funnels',
};

export const STORAGE_KEYS = {
  unilinkProfileId: 'unilinkProfileId',
  unilinkCloseSideBar: 'unilinkCloseSideBar',
  unilinkMarketingMenu: 'unilinkMarketingMenu',
  unilinkIsFullProduct: 'unilinkIsFullProduct',
  unilinkSoloAppView: 'unilinkSoloAppView',
  unilinkPagesView: 'unilinkPagesView',
  unilinkAddBlocksView: 'unilinkAddBlocksView',
};

export const FIELDS = {
  header: {
    layout: 'layout',
    viewType: 'viewType',
    profilePic: 'profilePic',
  },
  design: {
    backgroundColor: 'backgroundColor',
    textColor: 'textColor',
    margin: 'margin',
    marginTop: 'marginTop',
    marginBottom: 'marginBottom',
    padding: 'padding',
    paddingTop: 'paddingTop',
    paddingBottom: 'paddingBottom',
    opacity: 'opacity',
    blur: 'blur',
    brightness: 'brightness',
    contrast: 'contrast',
    isBackground: 'isBackground',
    backgroundType: 'backgroundType',
    backgroundStyle: 'backgroundStyle',
    backgroundImage: 'backgroundImage',
    gradientColor1: 'gradientColor1',
    gradientColor2: 'gradientColor2',
    gradientDirection: 'gradientDirection',
    gradientOffset: 'gradientOffset',

    shape: 'shape',
    border: 'border',
    borderColor: 'borderColor',
    shadow: 'shadow',
    shadowColor: 'shadowColor',
    isFullWidth: 'isFullWidth',

    height: 'height',
    isGradient: 'isGradient',
    rightIcon: 'rightIcon',
    textAlign: 'textAlign',

    isCustomHeight: 'isCustomHeight',
    minHeight: 'minHeight',
    // for preview
    titleColor: 'titleColor',
    descriptionColor: 'descriptionColor',
    buttonBackgroundColor: 'buttonBackgroundColor',
    buttonTextColor: 'buttonTextColor',
    buttonShape: 'buttonShape',
    buttonBorder: 'buttonBorder',
    buttonBorderColor: 'buttonBorderColor',
    buttonShadow: 'buttonShadow',
    buttonShadowColor: 'buttonShadowColor',
    labelBackgroundColor: 'labelBackgroundColor',
    imageShape: 'imageShape',
  },
  common: {
    cta: 'cta',
    links: 'links',
    items: 'items',
    contacts: 'contacts',
    faq: 'faqs',
    products: 'products',
    courses: 'courses',
    wallets: 'wallets',

    titleSize: 'titleSize',
    titleLineHeight: 'titleLineHeight',

    title: 'headingTitle',
    titleColor: 'headingTextColor',
    description: 'headingDescription',
    textAlign: 'headingTextAlign',
    image: 'headingImage',
    headingDivider: 'headingDivider',

    sectionBackgroundColor: 'sectionBackgroundColor',
    sectionBackgroundColorRGBA: 'sectionBackgroundRGBA',
    sectionTextColor: 'sectionTextColor',
    sectionOpacity: 'sectionOpacity',
    sectionIsBorder: 'sectionIsBorder',
    sectionBorder: 'sectionBorder',
    sectionIsFullWidth: 'sectionIsFullWidth',
    sectionMargin: 'sectionMargin',
    sectionPadding: 'sectionPadding',
    sectionIsBackground: 'isSectionBackground',
    sectionBackgroundType: 'sectionBackgroundType',
    sectionBackgroundImage: 'sectionBackgroundImage',
    sectionGradientColor1: 'sectionGradientColor1',
    sectionGradientColor2: 'sectionGradientColor2',
    sectionGradientDirection: 'sectionGradientDirection',
    sectionGradientOffset: 'sectionGradientOffset',
    sectionBorderColor: 'sectionBorderColor',
    sectionIsShadowBorder: 'sectionIsShadowBorder',
    sectionShadowBorderColor: 'sectionShadowBorderColor',
    sectionIsShadow: 'sectionIsShadow',
    sectionShadow: 'sectionShadow',
    sectionShadowColor: 'sectionShadowColor',
    sectionShape: 'sectionShape',

    itemBackgroundColor: 'itemBackgroundColor',
    itemBackgroundColorRGBA: 'itemBackgroundRGBA',
    itemTextColor: 'itemTextColor',
    itemImageSize: 'itemImageSize',
    itemImageShape: 'itemImageShape',
    itemAlign: 'itemAlign',
    itemShadow: 'itemShadow',
    itemShadowColor: 'itemShadowColor',
    itemShape: 'itemShape',
    itemBorder: 'itemBorder',
    itemBorderColor: 'itemBorderColor',
    itemOpacity: 'itemOpacity',

    buttonTitle: 'buttonTitle',
    buttonText: 'buttonText',
    buttonColor: 'buttonColor',
    submitButtonText: 'submitButtonText',
    buttonBackgroundColor: 'buttonColor',
    buttonBGColor: 'buttonBackgroundColor',
    buttonTextColor: 'buttonTextColor',
    buttonBorder: 'buttonBorder',
    buttonBorderColor: 'buttonBorderColor',
    buttonOpacity: 'buttonOpacity',
    buttonShape: 'buttonShape',
    buttonShadow: 'buttonShadow',
    buttonShadowColor: 'buttonShadowColor',

    viewType: 'viewType',
    view: 'view',
    layout: 'layout',
    display: 'display',
    channel: 'channel',
    url: 'url',
    content: 'content',
  },
  links: {
    links: 'links',
    buttonBorder: 'buttonBorder',
    buttonBorderColor: 'buttonBorderColor',
    buttonShape: 'buttonShape',
    buttonShadow: 'buttonShadow',
    buttonShadowColor: 'buttonShadowColor',

    defaultBtnTextAlign: 'defaultButtonTextAlign',
    defaultBtnRightIcon: 'defaultButtonRightIcon',
    defaultBtnIsGradient: 'defaultButtonIsGradient',
    defaultBtnGradientColor1: 'defaultButtonGradientColor1',
    defaultBtnGradientColor2: 'defaultButtonGradientColor2',
    defaultBtnGradientDirection: 'defaultButtonGradientDirection',
    defaultBtnGradientOffset: 'defaultButtonGradientOffset',

    defaultBtnBackgroundColor: 'defaultButtonBackgroundColor',
    defaultBtnTextColor: 'defaultButtonTextColor',
    defaultBtnOpacity: 'defaultButtonOpacity',
    defaultBtnHeight: 'defaultButtonHeight',
  },
  pageList: {
    items: 'items',
  },
  text: {
    title: 'title',
    textAlign: 'titleAlign',
    titleSize: 'titleSize',
    titleLineHeight: 'titleLineHeight',
    content: 'content',
    contentTrimCount: 'contentTrimCount',
    isContentTrim: 'isContentTrim',
  },
  form: {
    buttonTitle: 'buttonText',
    resultAction: 'formResultAction',
    resultData: 'formResultData',
    successMessage: 'formSuccessMessage',

    viewType: 'view',
    fields: 'formFields',

    isAddress: 'isFieldAddress',
    isComment: 'isFieldComment',
    isEmail: 'isFieldEmail',
    isName: 'isFieldName',
    isPhone: 'isFieldPhone',

    isAddressRequired: 'isFieldAddressRequired',
    isCommentRequired: 'isFieldCommentRequired',
    isEmailRequired: 'isFieldEmailRequired',
    isNameRequired: 'isFieldNameRequired',
    isPhoneRequired: 'isFieldPhoneRequired',

    buttonBackgroundColor: 'buttonBackgroundColor',
    buttonTextColor: 'buttonTextColor',
    buttonOpacity: 'buttonOpacity',
    buttonBorder: 'buttonBorder',
    buttonBorderColor: 'buttonBorderColor',
    buttonShadow: 'buttonShadow',
    buttonShadowColor: 'buttonShadowColor',
    buttonShape: 'buttonShape',
  },
  map: {
    code: 'embed',
    view: 'view',
    address: 'address',
    addressLink: 'addressUrl',
    addressButtonText: 'directionButtonText',
    addressIconType: 'directionButtonType',
    addressTitle: 'addressTitle',
    items: 'items',
  },
  shop: {
    items: 'custom',
    listView: 'listView',
    lists: 'lists',
    view: 'customView',
    layout: 'customLayout',
    postLayout: 'postLayout',
    postBackgroundColor: 'postBackgroundColor',
    postTextColor: 'postTextColor',
    postButtonBackgroundColor: 'postButtonBackgroundColor',
    postButtonTextColor: 'postButtonTextColor',
    postShadowColor: 'postShadowColor',
    postShadow: 'postShadow',
  },
  appointment: {
    token: 'calendlyAccessToken',
  },
  donation: {
    buttonBackgroundColor: 'buttonColor',
    buttonTextColor: 'buttonTextColor',
    icon: 'itemIcon',
    price: 'itemPrice',
    title: 'itemTitle',
    message: 'message',
    buttonTitle: 'buttonText',
    header: 'header',
    isComment: 'isComment',
    isName: 'isName',
    isPhone: 'isPhone',
    view: 'view',
    type: 'type',
    amounts: 'amounts',
    themeColor: 'themeColor',
    themeTextColor: 'rhemeTextColor',
  },
  nft: {
    items: 'nfts',
    layout: 'nftLayout',
    view: 'view',
  },
  youTube: {
    items: 'youTube',
    layout: 'layout',
    view: 'view',
  },
  twitter: {
    url: 'url',
  },
  banner: {
    height: 'height',
    bannerWidth: 'width',
    darkness: 'darkness',
    text: 'text',
    isText: 'isText',
    textColor: 'textColor',
    description: 'description',
    actionType: 'ctaType',
    ctaSite: 'ctaSite',
    ctaSiteText: 'ctaSiteText',
    ctaBackgroundColor: 'ctaBackgroundColor',
    ctaTextColor: 'ctaTextColor',
    ctaOpacity: 'ctaOpacity',
    ctaLinkId: 'ctaItemId',
    ctaBlockId: 'ctaBlockId',
    ctaBorder: 'ctaBorder',
    ctaBorderColor: 'ctaBorderColor',
    ctaShape: 'ctaShape',
    ctaShadow: 'ctaShadow',
    ctaShadowColor: 'ctaShadowColor',
    layout: 'widthView',
    heigthType: 'heightView',
    mediaHeader: 'mediaHeader',
    url: 'url',
    type: 'type',
  },
  spacer: {
    value: 'spacerValue',
  },
  timer: {
    position: 'position',
    label: 'label',
    title: 'title',
    backgroundColor: 'backgroundColor',
    textColor: 'textColor',
    opacity: 'opacity',
    icon: 'icon',
    linkId: 'linkId',
    type: 'type',
    timestamp: 'timestamp',
    tillDate: 'tillDate',
  },
};

export const BLOCK_TYPES = {
  header: 'header',
  text: 'text',
  links: 'link', // links
  dataCollect: 'data-collect',
  form: 'form',
  contacts: 'contact', // contacts
  faq: 'faq',
  features: 'feature', // contacts
  highlights: 'highlight', // contacts
  slider: 'slider',
  banner: 'banner',
  trust: 'trust', //trust
  gallery: 'gallery',
  blog: 'blog',
  map: 'map',
  footer: 'footer',
  chatAi: 'chat-ai',
  custom: 'custom',
  //--------------------------------
  splash: 'splash',
  promo: 'promo',
  file: 'file',
  stat: 'stat',

  // ------------ Make and collect money ------------
  shop: 'shop',
  digital: 'digital',
  appointment: 'appointment',
  service: 'service',
  tips: 'tip',
  donation: 'donation',
  course: 'course',
  event: 'event',
  membership: 'membership',
  pricing: 'pricing',
  booking: 'booking',
  nft: 'nft',
  wallet: 'wallet',
  menu: 'menu',

  // ------------ Social media content ------------
  youtube: 'youtube',
  instagram: 'instagram',
  tiktok: 'tiktok',
  twitter: 'twitter',
  music: 'music',
  twitch: 'twitch',

  // ------------ Social media content ------------
  welcome: 'welcome',
  review: 'review',
  coupon: 'coupon',
  timer: 'timer',
  outfit: 'outfit',
  spacer: 'spacer',
  html: 'html',

  video: 'video',
  pageList: 'page-list',
  timeline: 'timeline',
  listing: 'listing',
  overview: 'overview',
  rental: 'rental',
  singleProduct: 'single-product',
  team: 'team',
  timetable: 'timetable',
  unlock: 'unlock',
};

export const PATH_TYPES = {
  messages: 'messages',
  audience: 'audience',
  website: 'website/*',
  posts: 'posts/*',
  store: 'products/*',
  emailMarketing: 'email/*',
  socialPlanner: 'scheduler/*',
  shortLinks: 'short-links',
  accountSettings: 'account-settings',
  billingHistory: 'account-settings/billing-history',

  design: 'design',
  analytics: 'analytics',
  templates: 'templates',
  settings: 'settings/*',
  settingsProfile: 'profile',
  settingsEmail: 'email',
  settingsStorage: 'storage',
  settingsNotifications: 'notifications',
  settingsShop: 'shop',
  settingsPayments: 'payments',
  settingsAnalytics: 'analytics',
  settingsSeo: 'seo',
  settingsDomain: 'custom-domain',
  settingsWebhooks: 'webhooks',
  settingsSensitiveMaterial: 'sensitive-material',

  dataCollect: 'data-collect',
  appointments: 'appointments',
  gallery: 'gallery',
  blog: 'blog',
  outfit: 'outfit',
  request: 'services',
  html: 'html',
  digital: 'digital',
  appointment: 'appointment',
  course: 'course',
  coupons: 'coupons',
  review: 'review',
  coupon: 'coupon',
  service: 'service',
  features: 'feature',
  highlights: 'highlight',
  slider: 'slider',
  trust: 'trust',
  twitch: 'twitch',
  youtube: 'youtube',
  nft: 'nft',
  tiktok: 'tiktok',
  music: 'music',
  twitter: 'twitter',
  welcome: 'welcome',
  map: 'map',
  contacts: 'contact',
  timer: 'timer',
  faq: 'faq',
  donations: 'donations',
  donation: 'donation',
  tips: 'tip',
  event: 'event',
  wallet: 'wallet',
  form: 'form',
  subscribe: 'subscribe',
  looks: 'looks',
  instagram: 'instagram',
  shop: 'shop',
  links: 'link',
  text: 'text',
  banner: 'banner',
  spacer: 'spacer',
  header: 'header',
  promo: 'promo',
  footer: 'footer',
  splash: 'splash',
  courses: 'courses',
  ecommerce: 'ecommerce',
  events: 'events',
  membership: 'membership',
  podcast: 'podcast',
  etsy: 'etsy',
  shopify: 'shopify',
  spring: 'spring',
  promobar: 'promobar',
  splashScreen: 'splash',
  pricing: 'pricing',
  file: 'file',
  stat: 'stat',
  video: 'video',
  pageList: 'page-list',
  chatAi: 'chat-ai',
  custom: 'custom',
  menu: 'menu',
  timeline: 'timeline',
  booking: 'booking',
  listing: 'listing',
  overview: 'overview',
  rental: 'rental',
  singleProduct: 'single-product',
  team: 'team',
  timetable: 'timetable',
  unlock: 'unlock',
};

export const PATH_NAVIGATE = {
  website: '/website',
  websiteDesign: '/website/design',
  websiteAnalytics: '/analytics',
  websiteSettings: '/website/settings',
  websiteTemplates: '/website/templates',

  products: '/products',
  productsEarning: '/products/earning',
  productsOrders: '/products/orders',

  audience: '/audience',

  email: '/email',

  scheduler: '/scheduler',
  schedulerIntegrations: '/social-planner/integrations',
  post: '/posts',
  postMembership: '/posts/membership',

  linkShortener: '/short-links',
  border: '/border',

  event: '/website/event',
  outfit: '/website/outfit',
  course: '/website/course',
  coupon: '/website/coupon',
  service: '/website/service',
  promo: '/website/promo',
  header: '/website/header',
  banner: '/website/banner',
  text: '/website/text',
  links: '/website/link',
  dataCollect: '/website/data-collect',
  shop: '/website/shop',
  instagram: '/website/instagram',
  ecommerce: '/website/ecommerce',
  outfits: '/website/outfits',
  subscribe: '/website/subscribe',
  form: '/website/form',
  wallet: '/website/wallet',
  donation: '/website/donation',
  tips: '/website/tip',
  faq: '/website/faq',
  map: '/website/map',
  html: '/website/html',
  twitter: '/website/twitter',
  music: '/website/music',
  spacer: '/website/spacer',
  tiktok: '/website/tiktok',
  youtube: '/website/youtube',
  twitch: '/website/twitch',
  nft: '/website/nft',
  slider: '/website/slider',
  highlights: '/website/highlight',
  features: '/website/feature',
  review: '/website/review',
  appointment: '/website/appointment',
  gallery: '/website/gallery',
  blog: '/website/blog',
  chatAi: '/website/chat-ai',
  custom: '/website/custom',
  services: '/website/services',
  contacts: '/website/contact',
  digital: '/website/digital',
  coupons: '/website/coupons',
  welcome: '/website/welcome',
  footer: '/website/footer',
  events: '/website/events',
  courses: '/website/courses',
  membership: '/website/membership',
  pricing: '/website/pricing',
  timer: '/website/timer',
  file: '/website/file',
  stat: '/website/stat',
  video: '/website/video',
  pageList: '/website/page-list',
  trust: '/website/trust',
  menu: '/website/menu',
  timeline: '/website/timeline',
  booking: '/website/booking',
  listing: '/website/listing',
  overview: '/website/overview',
  rental: '/website/rental',
  singleProduct: '/website/single-product',
  team: '/website/team',
  timetable: '/website/timetable',
  unlock: '/website/unlock',
};

export const CONTACTS_LIST = [
  { id: 1, type: 'email', title: 'Email', icon: 'email.png', backgroundColor: '#61A5FF', placeholder: 'example@gmail.com', regex: 'mailto:example@gmail.com' },
  { id: 2, type: 'phone', title: 'Phone', icon: 'phone.png', backgroundColor: '#52C745', placeholder: '+4917640206387', regex: 'tel:+4917640206387' },
  { id: 3, type: 'whatsapp', title: 'WhatsApp', icon: 'whatsapp.png', backgroundColor: '#55CD6C', placeholder: '+15551234567', regex: 'https://wa.me/15551234567' },
  {
    id: 4,
    type: 'messenger',
    title: 'Facebook Messenger',
    icon: 'facebook-messenger.png',
    backgroundColor: '#0084FF',
    placeholder: '@pagename or https://facebook.com/pagename',
    regex: 'http://m.me/page_name',
  },
  {
    id: 5,
    type: 'instagram',
    title: 'Instagram',
    icon: 'instagram.png',
    backgroundColor: '#D2337A',
    placeholder: '@username or https://instagram.com/username',
    regex: 'https://ig.me/m/username',
  },
  {
    id: 6,
    type: 'telegram',
    title: 'Telegram',
    icon: 'telegram.png',
    backgroundColor: '#27A6E6',
    placeholder: '@username or https://t.me/username',
    regex: 'https://t.me/username',
  },
  { id: 7, type: 'viber', title: 'Viber', icon: 'viber.png', backgroundColor: '#7C529D', placeholder: '+15551234567', regex: 'viber://chat?number=15551234567' },
  { id: 8, type: 'skype', title: 'Skype', icon: 'skype.png', backgroundColor: '#00AFF0', placeholder: '@username or https://skype.com/username', regex: 'https://username' },
  {
    id: 9,
    type: 'linkedin',
    title: 'LinkedIn',
    icon: 'linkedin.png',
    backgroundColor: '#00AFF0',
    placeholder: '@username or https://linkedin.com/username',
    regex: 'https://username',
  },
  {
    id: 10,
    type: 'twitter',
    title: 'Twitter',
    icon: 'twitter.png',
    backgroundColor: '#1DA1F2',
    placeholder: '@username or https://twitter.com/username',
    regex: 'https://twitter.com/username',
  },
  {
    id: 11,
    type: 'location',
    title: 'Location',
    icon: 'location.png',
    backgroundColor: '#FF151E',
    placeholder: 'https://goo.gl/maps/xRinfSPLHSahD7GQ7',
    regex: 'https://goo.gl/maps/xRinfSPLHSahD7GQ7',
  },
  {
    id: 12,
    type: 'calendly',
    title: 'Calendly',
    icon: 'calendly.png',
    backgroundColor: '#00AFF0',
    placeholder: '@username or https://calendly.com/username',
    regex: 'https://username',
  },
  { id: 13, type: 'link', title: 'Link', icon: 'link.png', backgroundColor: '#00AFF0', placeholder: 'https://your-url', regex: 'https://your-url' },
  {
    id: 14,
    type: 'instagram-direct',
    title: 'Instagram Direct',
    icon: 'instagram.png',
    backgroundColor: '#D2337A',
    placeholder: '@username or https://instagram.com/username',
    regex: 'https://ig.me/m/username',
  },
  {
    id: 15,
    type: 'facebook',
    title: 'Facebook',
    icon: 'facebook.png',
    backgroundColor: '#0084FF',
    placeholder: '@pagename or https://facebook.com/pagename',
    regex: 'https://username',
  },
  {
    id: 18,
    type: 'x',
    title: 'X',
    icon: 'x.png',
    backgroundColor: '#000000',
    placeholder: '@username or https://x.com/username',
    regex: 'https://x.com/username',
  },
  {
    id: 20,
    type: 'youtube',
    title: 'YouTube',
    icon: 'youtube.png',
    backgroundColor: '#E21A20',
    placeholder: '@username',
    regex: 'https://youtube.com/@username',
    n: 17,
  },
  {
    id: 21,
    type: 'tiktok',
    title: 'TikTok',
    icon: 'tiktok.png',
    backgroundColor: '#000000',
    placeholder: '@username',
    regex: 'https://tiktok.com/@username',
    n: 18,
  },
  {
    id: 22,
    type: 'spotify',
    title: 'Spotify',
    icon: 'spotify.png',
    backgroundColor: '#000000',
    placeholder: '@username',
    regex: 'https://spotify.com/@username',
    n: 19,
  },
];
